export default __webpack_public_path__ + "ui/assets/img/remove-16-opacity.svg";